exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-container.login-page[data-v-056098db]{\n    height: 100%;\n}\nh1[data-v-056098db]{\n    color: white;\n    text-align: center;\n    font-weight: 900;\n}\n", ""]);

// exports
